module.exports = __webpack_public_path__ + "static/media/card_2x.072f1d4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/denver/card_2x.jpg
// module id = 935
// module chunks = 27